// extracted by mini-css-extract-plugin
module.exports = {"sorting":"DefaultSort_sorting__8t63O","sorting-item":"DefaultSort_sorting-item__JONvf"};